module.exports = __webpack_public_path__ + "img/logo_full.e8b649ad.png";